import {
  DataSource,
  initialPageableData,
} from '@sharedModule/models/data-source.model';
import { ConversionRateInterface } from '../types/currency-conversion-rate';
import {
  ConversionRateFilter,
  defaultConversionRateFilter,
} from '../types/currency-conversion-rate-filter';

export const CONVERSION_RATE_STATE = 'conversionRate';

export interface ConversionRateState {
  filter: ConversionRateFilter;
  dataSource: DataSource<ConversionRateInterface[]>;
}

export const initialDataSource: DataSource<ConversionRateInterface[]> =
  Object.freeze({
    ...initialPageableData,
    rawData: [],
  });

export const initialConversionRateState: ConversionRateState = Object.freeze({
  filter: defaultConversionRateFilter,
  dataSource: {
    ...initialDataSource,
  },
});
